export default {
      id: "incorrect-document-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#incorrect-document",
      toString: function () {
        return this.url;
      }
    }